<template>
  <div class="repeat-nav-container" :style="getAppearanceStyle">
    <div class="inner-container scroller" :style="getScrollStyle">
      <div class="vertical" ref="wrapRef" v-if="mode === 'vertical'" :style="getWrapStyle">
        <div class="nav-item" v-for="(option, index) in showList" :key="index" :style="getItemWidth(index)">
          <div class="nav-title"
            :class="[titleActiveIndex === index ? 'active' : '', !option.children || option.children.length === 0 ? 'pointer' : '']"
            :style="getTitleStyle" @click="selectClick(index, option, 'title')">
            <span v-if="getIconPosition === 'right'">{{
              options.topNavTextLimit ? option.label.substr(0, options.topNavTextLimitCount) : option.label
            }}</span>
            <cxIcon class="icon" v-if="iconType === 'icon' && showTopNavIcon" :options="options" :iconStyle="getIconStyle">
            </cxIcon>
            <img class="icon" v-if="iconType === 'img' && iconSrc && showTopNavIcon" :src="iconSrc"
              :style="getIconImgStyle" />
            <span v-if="getIconPosition === 'left'">{{
              options.topNavTextLimit ? option.label.substr(0, options.topNavTextLimitCount) : option.label
            }}</span>
          </div>
          <div class="nav-sub">
            <div class="nav-submenu" v-for="(child_option, child_index) in option.children"
              v-if="(limitSubNumber && child_index < maxSubNumber) || !limitSubNumber" :key="'child_' + child_index"
              :class="subActiveIndex === child_index ? 'active' : ''" :style="getSubStyle"
              @click="selectClick(index, option, 'title')">
              <span v-if="options.liIconPosition === 'right'">{{
                options.liTextLimit ? child_option.label.substr(0, options.liTextLimitCount) : child_option.label
              }}</span>
              <cxIcon class="icon" v-if="options.liIconType === 'icon' && options.showLiNavIcon" :options="options"
                :iconStyle="getLiIconStyle" iconSrcName="liIconSrc"></cxIcon>
              <img class="icon" v-if="options.liIconType === 'img' && options.liIconSrc && options.showLiNavIcon"
                :src="options.liIconSrc" :style="getLiIconImgStyle" />
              <span v-if="options.liIconPosition === 'left'">{{
                options.liTextLimit ? child_option.label.substr(0, options.liTextLimitCount) : child_option.label }}
              </span>
            </div>
          </div>
          <div class="more-btn" v-if="showSubMore && option.children && option.children.length > 0" :style="getMoreStyle">
            <span v-if="options.moreIconPosition === 'right'">{{
              options.moreTextLimit ? moreContent.substr(0, options.moreTextLimitCount) : moreContent
            }}</span>
            <cxIcon class="icon" v-if="options.moreIconType === 'icon' && options.showMoreNavIcon" :options="options"
              :iconStyle="getMoreIconStyle" iconSrcName="moreIconSrc"></cxIcon>
            <img class="icon" v-if="options.moreIconType === 'img' && options.moreIconSrc && options.showMoreNavIcon"
              :src="options.moreIconSrc" :style="getMoreIconImgStyle" />
            <span v-if="options.moreIconPosition === 'left'">{{
              options.moreTextLimit ? moreContent.substr(0, options.moreTextLimitCount) : moreContent
            }}
            </span>
          </div>
        </div>
      </div>
      <div class="horizontal scroller" v-else>
        <div class="nav-item verticallyTop" v-for="(option, index) in showList" :key="index">
          <div class="nav-title"
            :class="[titleActiveIndex === index ? 'active' : '', !option.children || option.children.length === 0 ? 'pointer' : '']"
            :style="getTitleStyle" @click="selectClick(index, option, 'title')">
            <span v-if="getIconPosition === 'right'">{{
              options.topNavTextLimit ? option.label.substr(0, options.topNavTextLimitCount) : option.label
            }}</span>
            <cxIcon class="icon" v-if="iconType === 'icon' && showTopNavIcon" :options="options" :iconStyle="getIconStyle">
            </cxIcon>
            <img class="icon" v-if="iconType === 'img' && iconSrc && showTopNavIcon" :src="iconSrc"
              :style="getIconImgStyle" />
            <span v-if="getIconPosition === 'left'">{{
              options.topNavTextLimit ? option.label.substr(0, options.topNavTextLimitCount) : option.label
            }}</span>
          </div>
          <div class="nav-sub tl">
            <div class="nav-submenu inlineMiddle" v-for="(child_option, child_index) in option.children"
              v-show="(limitSubNumber && child_index < maxSubNumber) || !limitSubNumber" :key="'child_' + child_index"
              :class="subActiveIndex === child_index ? 'active' : ''" :style="getSubStyle"
              @click="selectClick(child_index, child_option, 'sub')">
              <span v-if="options.liIconPosition === 'right'">{{
                options.liTextLimit ? child_option.label.substr(0, options.liTextLimitCount) : child_option.label
              }}</span>
              <cxIcon class="icon" v-if="options.liIconType === 'icon' && options.showLiNavIcon" :options="options"
                :iconStyle="getLiIconStyle" iconSrcName="liIconSrc"></cxIcon>
              <img class="icon" v-if="options.liIconType === 'img' && options.liIconSrc && options.showLiNavIcon"
                :src="options.liIconSrc" :style="getLiIconImgStyle" />
              <span v-if="options.liIconPosition === 'left'">{{
                options.liTextLimit ? child_option.label.substr(0, options.liTextLimitCount) : child_option.label }}
              </span>
            </div>
          </div>
          <div class="more-btn" v-if="showSubMore && option.children && option.children.length > 0" :style="getMoreStyle">
            <span v-if="options.moreIconPosition === 'right'">{{
              options.moreTextLimit ? moreContent.substr(0, options.moreTextLimitCount) : moreContent
            }}</span>
            <cxIcon class="icon" v-if="options.moreIconType === 'icon' && options.showMoreNavIcon" :options="options"
              :iconStyle="getMoreIconStyle" iconSrcName="moreIconSrc"></cxIcon>
            <img class="icon" v-if="options.moreIconType === 'img' && options.moreIconSrc && options.showMoreNavIcon"
              :src="options.moreIconSrc" :style="getMoreIconImgStyle" />
            <span v-if="options.moreIconPosition === 'left'">{{
              options.moreTextLimit ? moreContent.substr(0, options.moreTextLimitCount) : moreContent
            }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mode === 'vertical' && options.changeWay === 'button'">
      <div
        :class="['button_style', 'button-prev', 'button-prev' + ids.rect_id]"
        :style="buttonStyle"
        @click.stop="buttonClick('prev')"
      >
        <cxIcon
          v-if="buttonIconType === 'icon' && buttonIconSrc"
          :options="options"
          :iconStyle="buttonIconStyle"
          iconSrcName="buttonIconSrc"
        ></cxIcon>
        <img v-else-if="buttonIconType === 'img' && iconSrc" :src="buttonIconSrc" :style="buttonIconStyle" />
        <span v-else :class="'icon ' + options.buttonIconClassName"></span>
      </div>
      <div :class="['button_style', 'button-next', 'button-next' + ids.rect_id]" :style="buttonStyle"
        @click.stop="buttonClick('next')">
        <cxIcon v-if="buttonIconType === 'icon' && buttonIconSrc" :options="options" :iconStyle="buttonIconStyle"
          iconSrcName="buttonIconSrc"></cxIcon>
        <img v-else-if="buttonIconType === 'img' && buttonIconSrc" :src="buttonIconSrc" :style="buttonIconStyle" />
        <span v-else :class="'icon ' + options.buttonIconClassName"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { v1 } from "uuid"
import eventMixin from "utils/event/eventMixin.js"
import { repairApp } from "utils/saveModule"
export default {
  mixins: [eventMixin],
  components: {},
  props: {
    options: {
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeIndex: "0",
      update: false,
      uuid: v1(),
      startIndex: 0,
      titleActiveIndex: null,
      subActiveIndex: null,
      // 表示重置标识，0为普通切换，-1为0下标向左切换，1为length - 1下标向右切换
      resetFlag: 0,
      showAnimation: true
    }
  },
  watch: {
    // 切换样式更新数据
    "options.encId": function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.initNavData()
      }
    },
    "options.selectOptions": function (newVal, oldVal) {
      let optionsLength = newVal.length
      let widthLength = this.options?.widthList?.length
      if (optionsLength !== widthLength) {
        let widthList = JSON.parse(JSON.stringify(this.options.widthList))
        if (this.options.widthAuto) {// 平均宽度 需要重置widthList
          widthList = []
          for (let i = 0 ; i < optionsLength ; i++) {
            widthList.push(parseFloat(100 / this.options.showColNumber).toFixed(2))
          }
        } else {
          if (widthLength > optionsLength) {
            for (let i = widthLength - 1 ; i > optionsLength - 1 ; i--) {
              widthList.splice(i, 1)
            }
          }
          if (widthLength < optionsLength) {// 宽度自定义 只需要修改新增的
            for (let i = optionsLength - 1 ; i > widthLength - 1 ; i--) {
              widthList.push(parseFloat(100 / this.options.showColNumber).toFixed(2))
            }
          }
        }
        this.$changeOptionsEV(widthList, "widthList", false)
      }
      this.startIndex = 0
    },
    "options.showColNumber": function (newVal, oldVal) {
      if (newVal !== oldVal && this.options.widthAuto) {//只有宽度平均时需要修改
        let list = []
        for (let i = 0; i < this.options.selectOptions.length; i++) {
          list.push(parseFloat(100 / newVal).toFixed(2))
        }
        this.$changeOptionsEV(list, "widthList", false)
      }
    }
  },
  computed: {
    ids() {
      return this.myid
    },
    mode() {
      return this.options.mode
    },
    collapse() {
      return this.options.collapse
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    showTopNavIcon() {
      return this.options.showTopNavIcon
    },
    limitSubNumber() {
      return this.options.limitSubNumber
    },
    maxSubNumber() {
      return this.options.hasOwnProperty("maxSubNumber") ? this.options.maxSubNumber : 7
    },
    showSubMore() {
      return this.options.showSubMore
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition : "left"
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : `0 0 0 ${this.options.iconMargin}px`
    },
    getIconStyle() {
      return {
        display: "inline-block",
        "vertical-align": "middle",
        "--color": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        fontSize: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getLiMargin() {
      return this.options.liIconPosition === "left"
        ? `0 ${this.options.liIconWidth}px 0 0`
        : `0 0 0 ${this.options.liIconWidth}px`
    },
    getLiIconStyle() {
      return {
        display: "inline-block",
        "vertical-align": "middle",
        "--color": this.$parseColor(this.options.liIconColor, {
          isThemeColor: this.options.liIconColorIsThemeColor
        }),
        fontSize: this.options.liIconWidth + "px",
        width: this.options.liIconWidth + "px",
        height: this.options.liIconWidth + "px",
        margin: this.getLiMargin
      }
    },
    getLiIconImgStyle() {
      return {
        width: this.options.liIconWidth + "px",
        margin: this.getLiMargin
      }
    },
    getLiMargin() {
      return this.options.liIconPosition === "left"
        ? `0 ${this.options.liIconWidth}px 0 0`
        : `0 0 0 ${this.options.liIconWidth}px`
    },
    moreContent() {
      return this.options.hasOwnProperty("moreContent") ? this.options.moreContent : "更多"
    },
    getMoreIconStyle() {
      return {
        display: "inline-block",
        "vertical-align": "middle",
        "--color": this.$parseColor(this.options.moreIconColor, {
          isThemeColor: this.options.moreIconColorIsThemeColor
        }),
        fontSize: this.options.moreIconWidth + "px",
        width: this.options.moreIconWidth + "px",
        height: this.options.moreIconWidth + "px",
        margin: this.getMoreMargin
      }
    },
    getMoreIconImgStyle() {
      return {
        width: this.options.moreIconWidth + "px",
        margin: this.getMoreMargin
      }
    },
    getMoreMargin() {
      return this.options.moreIconPosition === "left"
        ? `0 ${this.options.moreIconMargin}px 0 0`
        : `0 0 0 ${this.options.moreIconMargin}px`
    },
    backgroundColor() {
      // return this.options.bgIsThemeColor ? this.themeColor : this.options.bgColor
      return this.$parseColor(this.options.bgColor, {
        isThemeColor: this.options.bgIsThemeColor
      })
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    topNavBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.topNavBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.topNavBgColorIsThemeColor ? true : false,
            color: this.options.topNavBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    hoverBgStyle() {
      if (this.options.hoverIsSameActive) {
        return {
          "--hoverBackgroundImage": this.activeBg.backgroundImage,
          "--hoverBackgroundSize": this.activeBg.backgroundSize,
          "--hoverBackgroundPosition": this.activeBg.backgroundPosition,
          "--hoverBackgroundRepeat": this.activeBg.backgroundRepeat,
          "--hoverBackgroundColor": this.activeBg.backgroundColor
        }
      }
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.hoverBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hoverBgIsThemeColor ? true : false,
            color:
              this.options.hoverBgColor && this.options.hoverBgColor.color
                ? this.options.hoverBgColor.color
                : this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return {
        "--hoverBackgroundImage": containerBg.backgroundImage,
        "--hoverBackgroundSize": containerBg.backgroundSize,
        "--hoverBackgroundPosition": containerBg.backgroundPosition,
        "--hoverBackgroundRepeat": containerBg.backgroundRepeat,
        "--hoverBackgroundColor": containerBg.backgroundColor
      }
    },
    activeBg() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.activeBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.activeBgIsThemeColor ? true : false,
            color:
              this.options.activeBgColor && this.options.activeBgColor.color
                ? this.options.activeBgColor.color
                : this.options.activeBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    activeBgStyle() {
      return {
        "--activeBackgroundImage": this.activeBg.backgroundImage,
        "--activeBackgroundSize": this.activeBg.backgroundSize,
        "--activeBackgroundPosition": this.activeBg.backgroundPosition,
        "--activeBackgroundRepeat": this.activeBg.backgroundRepeat,
        "--activeBackgroundColor": this.activeBg.backgroundColor
      }
    },
    liBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.liBgColorIsThemeColor ? true : false,
            color: this.options.liBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    liActiveBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liActiveBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.liActiveBgColorIsThemeColor ? true : false,
            color: this.options.liActiveBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    moreBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.moreBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.moreBgColorIsThemeColor ? true : false,
            color: this.options.moreBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    moreActiveBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.moreActiveBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.moreActiveBgColorIsThemeColor ? true : false,
            color: this.options.moreActiveBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    topNavBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.topNavBoxShadowH)) {
        this.options.topNavBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.topNavBoxShadowH[index]}px ${_this.options.topNavBoxShadowV[index]}px ${_this.options.topNavBoxShadowBlur[index]}px ${_this.options.topNavBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.topNavBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.topNavBoxShadowH}px ${this.options.topNavBoxShadowV}px ${this.options.topNavBoxShadowBlur}px ${this.options.topNavBoxShadowSpread}px ${this.$parseColor(this.options.topNavBoxShadowColor)}`
      }
      return tmpStyle
    },
    activeTopNavBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.activeTopNavBoxShadowH)) {
        this.options.activeTopNavBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.activeTopNavBoxShadowH[index]}px ${_this.options.activeTopNavBoxShadowV[index]}px ${_this.options.activeTopNavBoxShadowBlur[index]}px ${_this.options.activeTopNavBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.activeTopNavBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.activeTopNavBoxShadowH}px ${this.options.activeTopNavBoxShadowV}px ${this.options.activeTopNavBoxShadowBlur}px ${this.options.activeTopNavBoxShadowSpread}px ${this.$parseColor(this.options.activeTopNavBoxShadowColor)}`
      }
      return tmpStyle
    },
    liBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.liBoxShadowH)) {
        this.options.liBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.liBoxShadowH[index]}px ${_this.options.liBoxShadowV[index]}px ${_this.options.liBoxShadowBlur[index]}px ${_this.options.liBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.liBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.liBoxShadowH}px ${this.options.liBoxShadowV}px ${this.options.liBoxShadowBlur}px ${this.options.liBoxShadowSpread}px ${this.$parseColor(this.options.liBoxShadowColor)}`
      }
      return tmpStyle
    },
    liActiveBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.liActiveBoxShadowH)) {
        this.options.liActiveBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.liActiveBoxShadowH[index]}px ${_this.options.liActiveBoxShadowV[index]}px ${_this.options.liActiveBoxShadowBlur[index]}px ${_this.options.liActiveBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.liActiveBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.liActiveBoxShadowH}px ${this.options.liActiveBoxShadowV}px ${this.options.liActiveBoxShadowBlur}px ${this.options.liActiveBoxShadowSpread}px ${this.$parseColor(this.options.liActiveBoxShadowColor)}`
      }
      return tmpStyle
    },
    buttonBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.buttonBoxShadowH)) {
        this.options.buttonBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.buttonBoxShadowH[index]}px ${_this.options.buttonBoxShadowV[index]}px ${_this.options.buttonBoxShadowBlur[index]}px ${_this.options.buttonBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.buttonBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.buttonBoxShadowH}px ${this.options.buttonBoxShadowV}px ${this.options.buttonBoxShadowBlur}px ${this.options.buttonBoxShadowSpread}px ${this.$parseColor(this.options.buttonBoxShadowColor)}`
      }
      return tmpStyle
    },
    buttonIconStyle() {
      return {
        "--color": this.$parseColor(this.options.buttonIconColor, {
          isThemeColor: this.options.buttonIconColorIsThemeColor
        }),
        fontSize: this.options.buttonIconSize + "px",
        width: this.options.buttonIconSize + "px",
        height: this.options.buttonIconSize + "px"
      }
    },
    moreBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.moreBoxShadowH)) {
        this.options.moreBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.moreBoxShadowH[index]}px ${_this.options.moreBoxShadowV[index]}px ${_this.options.moreBoxShadowBlur[index]}px ${_this.options.moreBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.moreBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.moreBoxShadowH}px ${this.options.moreBoxShadowV}px ${this.options.moreBoxShadowBlur}px ${this.options.moreBoxShadowSpread}px ${this.$parseColor(this.options.moreBoxShadowColor)}`
      }
      return tmpStyle
    },
    moreActiveBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.moreActiveBoxShadowH)) {
        this.options.moreActiveBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.moreActiveBoxShadowH[index]}px ${_this.options.moreActiveBoxShadowV[index]}px ${_this.options.moreActiveBoxShadowBlur[index]}px ${_this.options.moreActiveBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.moreActiveBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.moreActiveBoxShadowH}px ${this.options.moreActiveBoxShadowV}px ${this.options.moreActiveBoxShadowBlur}px ${this.options.moreActiveBoxShadowSpread}px ${this.$parseColor(this.options.moreActiveBoxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.topNavPadding}px`
      if (!this.options.topNavPaddingTypeFlag || this.options.topNavPaddingTypeFlag === 2) {
        padding = ` ${this.options.topNavPaddingTop}px  ${this.options.topNavPaddingRight}px  ${this.options.topNavPaddingBottom}px  ${this.options.topNavPaddingLeft}px`
      }
      return padding
    },
    getActivePaddingStyle() {
      let padding = `${this.options.activeTopNavPadding}px`
      if (!this.options.activeTopNavPaddingTypeFlag || this.options.activeTopNavPaddingTypeFlag === 2) {
        padding = ` ${this.options.activeTopNavPaddingTop}px  ${this.options.activeTopNavPaddingRight}px  ${this.options.activeTopNavPaddingBottom}px  ${this.options.activeTopNavPaddingLeft}px`
      }
      return padding
    },
    selectOptions() {
      return this.options.selectOptions
    },
    showList() {
      if (this.options.changeWay === "scroll" || this.mode === "horizontal") {
        return this.selectOptions
      } else {
        if (this.canSwitchPage) {
          return [...this.selectOptions, ...this.selectOptions]
        }
        return this.selectOptions
      }
    },
    canSwitchPage() {
      if (this.options.changeWay === "button") {
        if (this.options.widthAuto && Number(this.options.showColNumber) < this.selectOptions.length) {
          return true
        }
        const totalWidth = this.options.widthList.reduce((pre, post) => Number(pre) + Number(post), 0)
        if (!this.options.widthAuto && totalWidth > 100) {
          return true
        }
      }
      return false
    },
    getAppearanceStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let padding = `${this.options.padding}px`
      if (!this.options.paddingTypeFlag || this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return {
        ...this.bgStyle,
        padding: padding,
        opacity: this.options.opacity / 100,
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": borderW,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "--item-width": "",
      }
    },
    getTitleStyle() {
      let topNavBorderW = "",
        activeTopNavBorderW = "",
         actualLineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100 *
           this.options.fontSize) : this.options.lineHeightType === 'normal'? this.options.fontSize *1.5
            :this.options.lineHeight,
          showLineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) :
              this.options.lineHeightType === 'normal'? "normal" :this.options.lineHeight + "px",
          height = actualLineHeight
      if (Array.isArray(this.options.topNavBorderWidth)) {
        this.options.topNavBorderWidth.forEach(item => [(topNavBorderW += ` ${item}px`)])
        height = `${height}+${this.options.topNavBorderWidth[0]} + ${this.options.topNavBorderWidth[1]}px`
      } else {
        topNavBorderW += ` ${this.options.topNavBorderWidth}px`
        height = `${height + 2 * this.options.topNavBorderWidth}px`
      }
      if (Array.isArray(this.options.activeTopNavBorderWidth)) {
        this.options.activeTopNavBorderWidth.forEach(item => [(activeTopNavBorderW += ` ${item}px`)])
      } else {
        activeTopNavBorderW += ` ${this.options.activeTopNavBorderWidth}px`
      }
      let bg = {
        "--backgroundImage": this.topNavBgStyle?.backgroundImage,
        "--backgroundSize": this.topNavBgStyle?.backgroundSize,
        "--backgroundPosition": this.topNavBgStyle?.backgroundPosition,
        "--backgroundRepeat": this.topNavBgStyle?.backgroundRepeat,
        "--backgroundColor": this.topNavBgStyle?.backgroundColor
      }
      let activeColor = this.$parseColor(this.options.activeFontColor, {
        isThemeColor: this.options.activeTextIsThemeColor
      })
      return {
        ...bg,
        "--color": this.$parseColor(this.options.color, {
          isThemeColor: this.options.textIsThemeColor
        }),
        "--lineHeight": showLineHeight,
        "--fontWeight": this.options.fontWeight,
        "--fontSize": this.options.fontSize + "px",
        "--fontStyle": this.options.fontStyle,
        "--fontFamily": this.options.fontFamily,
        "--textAlign": this.options.textAlign,
        "--writingMode": this.options.writingMode,
        "--letterSpacing": this.options.letterSpacing + "px",
        "--textDecoration": this.options.textDecoration,
        "--opacity": this.options.opacity / 100,
        "--borderRadius": `${this.options.topNavBorderTopLeftRadius}px ${this.options.topNavBorderTopRightRadius}px ${this.options.topNavBorderBottomRightRadius}px ${this.options.topNavBorderBottomLeftRadius}px`,
        "--borderStyle": this.options.topNavBorderStyle,
        "--borderColor": this.$parseColor(this.options.topNavBorderColor, {
          isThemeColor: this.options.topNavBorderIsThemeColor
        }),
        "--borderWidth": topNavBorderW,
        "--boxShadow": this.topNavBoxShadowStyle,
        "--padding": this.getPaddingStyle,
        "--width": this.mode === "horizontal" ? this.options.navWidth + "px" : "",

        ...this.activeBgStyle,
        "--activeColor": activeColor,
        "--activeFontWeight": this.options.activeFontWeight,
        "--activeFontSize": this.options.activeFontSize + "px",
        "--activeFontFamily": this.options.activeFontFamily,
        "--activeTextAlign": this.options.activeTextAlign,
        "--activeLineHeight": this.options.activeLineHeightType === '%' ? (this.options.activeLineHeight / 100) :
            this.options.activeLineHeightType === 'normal'? "normal" :this.options.activeLineHeight + "px",
        "--activeWritingMode": this.options.activeWritingMode,
        "--activeLetterSpacing": this.options.activeLetterSpacing + "px",
        "--activeTextDecoration": this.options.activeTextDecoration,
        "--activeFontStyle": this.options.activeFontStyle,
        "--activeBorderWidth": activeTopNavBorderW,
        // "--activeBorderStyle": this.options.activeBorderStyle,
        // "--activeBorderColor": this.options.activeBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.activeBorderColor && this.options.activeBorderColor.color
        //     ? this.options.activeBorderColor.color
        //     : this.options.activeBorderColor,
        "--activeBorderRadius": `${this.options.activeTopNavBorderTopLeftRadius}px ${this.options.activeTopNavBorderTopRightRadius}px ${this.options.activeTopNavBorderBottomRightRadius}px ${this.options.activeTopNavBorderBottomLeftRadius}px`,
        "--activeBorderStyle": this.options.activeTopNavBorderStyle,
        "--activeBorderColor": this.$parseColor(this.options.activeTopNavBorderColor, {
          isThemeColor: this.options.activeTopNavBorderIsThemeColor
        }),
        "--activeBoxShadow": this.activeTopNavBoxShadowStyle,
        "--activePadding": this.getActivePaddingStyle,
      }
    },
    getSubStyle() {
      let borderW = "",
        activeBorderW = ""
      if (Array.isArray(this.options.liBorderWidth)) {
        this.options.liBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.liBorderWidth}px`
      }
      borderW = borderW.trim()
      if (Array.isArray(this.options.liActiveBorderWidth)) {
        this.options.liActiveBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
      } else {
        activeBorderW += ` ${this.options.liActiveBorderWidth}px`
      }
      let subPadding = `${this.options.liPadding}px`
      if (!this.options.liPaddingTypeFlag || this.options.liPaddingTypeFlag === 2) {
        subPadding = ` ${this.options.liPaddingTop}px  ${this.options.liPaddingRight}px  ${this.options.liPaddingBottom}px  ${this.options.liPaddingLeft}px`
      }
      let activeSubPadding = `${this.options.liActivePadding}px`
      if (!this.options.liActivePaddingTypeFlag || this.options.liActivePaddingTypeFlag === 2) {
        activeSubPadding = ` ${this.options.liActivePaddingTop}px  ${this.options.liActivePaddingRight}px  ${this.options.liActivePaddingBottom}px  ${this.options.liActivePaddingLeft}px`
      }

      let bg = {
        "--backgroundImage": this.liBgStyle?.backgroundImage,
        "--backgroundSize": this.liBgStyle?.backgroundSize,
        "--backgroundPosition": this.liBgStyle?.backgroundPosition,
        "--backgroundRepeat": this.liBgStyle?.backgroundRepeat,
        "--backgroundColor": this.liBgStyle?.backgroundColor
      }
      let activeBg = {
        "--activeBackgroundImage": this.liActiveBgStyle?.backgroundImage,
        "--activeBackgroundSize": this.liActiveBgStyle?.backgroundSize,
        "--activeBackgroundPosition": this.liActiveBgStyle?.backgroundPosition,
        "--activeBackgroundRepeat": this.liActiveBgStyle?.backgroundRepeat,
        "--activeBackgroundColor": this.liActiveBgStyle?.backgroundColor
      }
      return {
        ...bg,
        "--lineHeight": this.options.liLineHeightType === '%' ? (this.options.liLineHeight / 100) :
            this.options.liLineHeightType === 'normal'? "normal" :this.options.liLineHeight + "px",
        "--color": this.$parseColor(this.options.liFontColor, {
          isThemeColor: this.options.liIsThemeColor
        }),
        "--fontWeight": this.options.liFontWeight,
        "--fontSize": this.options.liFontSize + "px",
        "--fontStyle": this.options.liFontStyle,
        "--fontFamily": this.options.liFontFamily,
        "--textAlign": this.options.liTextAlign,
        "--writingMode": this.options.liWritingMode,
        "--letterSpacing": this.options.liLetterSpacing + "px",
        "--textDecoration": this.options.liTextDecoration,
        "--borderRadius": `${this.options.liBorderTopLeftRadius}px ${this.options.liBorderTopRightRadius}px ${this.options.liBorderBottomRightRadius}px ${this.options.liBorderBottomLeftRadius}px`,
        "--borderWidth": borderW,
        "--borderStyle": this.options.liBorderStyle,
        "--borderColor": this.$parseColor(this.options.liBorderColor, {
          isThemeColor: this.options.liBorderIsThemeColor
        }),
        "--padding": subPadding,
        "--boxShadow": this.liBoxShadowStyle,
        "margin-bottom": this.options.lineMargin + "px",
        "margin-right": this.options.columnMargin + "px",

        ...activeBg,
        "--activeLineHeight": this.options.liActiveLineHeightType === '%' ? (this.options.liActiveLineHeight / 100) :
            this.options.liActiveLineHeightType === 'normal'? "normal" :this.options.liActiveLineHeight + "px",
        "--activeColor": this.$parseColor(this.options.liActiveFontColor, {
          isThemeColor: this.options.liActiveIsThemeColor
        }),
        "--activeFontWeight": this.options.liActiveFontWeight,
        "--activeFontSize": this.options.liActiveFontSize + "px",
        "--activeFontStyle": this.options.liActiveFontStyle,
        "--activeFontFamily": this.options.liActiveFontFamily,
        "--activeTextAlign": this.options.liActiveTextAlign,
        "--activeWritingMode": this.options.liActiveWritingMode,
        "--activeLetterSpacing": this.options.liActiveLetterSpacing + "px",
        "--activeTextDecoration": this.options.liActiveTextDecoration,
        "--activeBorderRadius": `${this.options.liActiveBorderTopLeftRadius}px ${this.options.liActiveBorderTopRightRadius}px ${this.options.liActiveBorderBottomRightRadius}px ${this.options.liActiveBorderBottomLeftRadius}px`,
        "--activeBorderWidth": activeBorderW,
        "--activeBorderStyle": this.options.liActiveBorderStyle,
        "--activeBorderColor": this.$parseColor(this.options.liActiveBorderColor, {
          isThemeColor: this.options.liActiveBorderIsThemeColor
        }),
        "--activePadding": activeSubPadding,
        "--activeBoxShadow": this.liActiveBoxShadowStyle,
      }
    },
    getMoreStyle() {
      let borderW = "",
        activeBorderW = ""
      if (Array.isArray(this.options.moreBorderWidth)) {
        this.options.moreBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.moreBorderWidth}px`
      }
      borderW = borderW.trim()
      if (Array.isArray(this.options.moreActiveBorderWidth)) {
        this.options.moreActiveBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
      } else {
        activeBorderW += ` ${this.options.moreActiveBorderWidth}px`
      }
      let subPadding = `${this.options.morePadding}px`
      if (!this.options.morePaddingTypeFlag || this.options.morePaddingTypeFlag === 2) {
        subPadding = ` ${this.options.morePaddingTop}px  ${this.options.morePaddingRight}px  ${this.options.morePaddingBottom}px  ${this.options.morePaddingLeft}px`
      }
      let activeSubPadding = `${this.options.moreActivePadding}px`
      if (!this.options.moreActivePaddingTypeFlag || this.options.moreActivePaddingTypeFlag === 2) {
        activeSubPadding = ` ${this.options.moreActivePaddingTop}px  ${this.options.moreActivePaddingRight}px  ${this.options.moreActivePaddingBottom}px  ${this.options.moreActivePaddingLeft}px`
      }

      let bg = {
        "--backgroundImage": this.moreBgStyle?.backgroundImage,
        "--backgroundSize": this.moreBgStyle?.backgroundSize,
        "--backgroundPosition": this.moreBgStyle?.backgroundPosition,
        "--backgroundRepeat": this.moreBgStyle?.backgroundRepeat,
        "--backgroundColor": this.moreBgStyle?.backgroundColor
      }
      let activeBg = {
        "--activeBackgroundImage": this.moreActiveBgStyle?.backgroundImage,
        "--activeBackgroundSize": this.moreActiveBgStyle?.backgroundSize,
        "--activeBackgroundPosition": this.moreActiveBgStyle?.backgroundPosition,
        "--activeBackgroundRepeat": this.moreActiveBgStyle?.backgroundRepeat,
        "--activeBackgroundColor": this.moreActiveBgStyle?.backgroundColor
      }
      return {
        ...bg,
        "--lineHeight": this.options.moreLineHeightType === '%' ? (this.options.moreLineHeight / 100) :
            this.options.moreLineHeightType === 'normal'? "normal" :this.options.moreLineHeight + "px",
        "--color": this.$parseColor(this.options.moreFontColor, {
          isThemeColor: this.options.moreIsThemeColor
        }),
        "--fontWeight": this.options.moreFontWeight,
        "--fontSize": this.options.moreFontSize + "px",
        "--fontStyle": this.options.moreFontStyle,
        "--fontFamily": this.options.moreFontFamily,
        "--textAlign": this.options.moreTextAlign,
        "--writingMode": this.options.moreWritingMode,
        "--letterSpacing": this.options.moreLetterSpacing + "px",
        "--textDecoration": this.options.moreTextDecoration,
        "--borderRadius": `${this.options.moreBorderTopLeftRadius}px ${this.options.moreBorderTopRightRadius}px ${this.options.moreBorderBottomRightRadius}px ${this.options.moreBorderBottomLeftRadius}px`,
        "--borderWidth": borderW,
        "--borderStyle": this.options.moreBorderStyle,
        "--borderColor": this.$parseColor(this.options.moreBorderColor, {
          isThemeColor: this.options.moreBorderIsThemeColor
        }),
        "--padding": subPadding,
        "--boxShadow": this.moreBoxShadowStyle,

        ...activeBg,
        "--activeLineHeight": this.options.moreActiveLineHeightType === '%' ? (this.options.moreActiveLineHeight / 100) :
            this.options.moreActiveLineHeightType === 'normal'? "normal" :this.options.moreActiveLineHeight + "px",
        "--activeColor": this.$parseColor(this.options.moreActiveFontColor, {
          isThemeColor: this.options.moreActiveIsThemeColor
        }),
        "--activeFontWeight": this.options.moreActiveFontWeight,
        "--activeFontSize": this.options.moreActiveFontSize + "px",
        "--activeFontStyle": this.options.moreActiveFontStyle,
        "--activeFontFamily": this.options.moreActiveFontFamily,
        "--activeTextAlign": this.options.moreActiveTextAlign,
        "--activeWritingMode": this.options.moreActiveWritingMode,
        "--activeLetterSpacing": this.options.moreActiveLetterSpacing + "px",
        "--activeTextDecoration": this.options.moreActiveTextDecoration,
        "--activeBorderRadius": `${this.options.moreActiveBorderTopLeftRadius}px ${this.options.moreActiveBorderTopRightRadius}px ${this.options.moreActiveBorderBottomRightRadius}px ${this.options.moreActiveBorderBottomLeftRadius}px`,
        "--activeBorderWidth": activeBorderW,
        "--activeBorderStyle": this.options.moreActiveBorderStyle,
        "--activeBorderColor": this.$parseColor(this.options.moreActiveBorderColor, {
          isThemeColor: this.options.moreActiveBorderIsThemeColor
        }),
        "--activePadding": activeSubPadding,
        "--activeBoxShadow": this.moreActiveBoxShadowStyle,
      }
    },
    getScrollStyle() {
      let style = {}
      if (this.options.changeWay === "scroll") {
        style = {
          "overflow-y": this.mode === "vertical" ? "hidden" : "auto",
          "overflow-x": this.mode === "vertical" ? "auto" : "hidden"
        }
      }
      return style
    },
    buttonStyle() {
      return {
        "--button-size": this.options.buttonIconSize + "px",
        "--button-color": this.$parseColor(this.options.buttonIconColor),
        "--button-box-padding": this.options.buttonIconPadding + "px",
        "--button-box-left-x": this.options.buttonIconCustomTop
          ? this.options.leftButtonIconX + "px"
          : this.options.buttonIconPadding + "px",
        "--button-box-left-y": this.options.buttonIconCustomTop ? this.options.leftButtonIconY + "px" : 0,
        "--button-box-right-x": this.options.buttonIconCustomTop
          ? this.options.rightButtonIconX + "px"
          : this.options.buttonIconPadding + "px",
        "--button-box-right-y": this.options.buttonIconCustomTop ? this.options.rightButtonIconY + "px" : 0,
        background: this.$parseColor(this.options.buttonIconBackgroundColor, {
          isThemeColor: this.options.iconBgIsThemeColor
        }),
        "border-radius": this.options.buttonIconBackGroundBorderRadius + "px",
        width: this.options.buttonIconBackgroundWidth + "px",
        height: this.options.buttonIconBackgroundHeight + "px",
        "box-shadow": this.buttonBoxShadowStyle,
        cursor: this.canSwitchPage ? "pointer" : "default"
      }
    },
    buttonIconType() {
      return this.options.buttonIconType ? this.options.buttonIconType : "icon"
    },
    buttonIconSrc() {
      return this.options.buttonIconSrc ? this.options.buttonIconSrc : ""
    },
    getWrapStyle() {
      let style = {}
      if (this.options?.widthList?.length > 0) {
        if (this.mode === "vertical") {
          if (this.canSwitchPage || this.options.changeWay === "scroll") {
            const avg = +parseFloat(100 / Number(this.options.showColNumber)).toFixed(2)
            const sum = this.options.widthAuto
              ? avg * this.selectOptions.length
              : this.options.widthList.reduce((curr, next) => {
                  return Number(curr) + Number(next)
                })
            if (this.options.changeWay === "scroll") {
              style.width = sum + "%"
            } else {
              style.width = sum * 2 + "%"
              let curProcess = 0
              for (let i = 0; i < this.startIndex; i++) {
                if (this.options.widthAuto) {
                  curProcess += avg
                } else {
                  curProcess += Number(this.options.widthList[i % this.options.widthList.length])
                }
              }
              curProcess = (((curProcess / sum) * 100) / 2).toFixed(2)
              style.transform = `translate3d(calc(-${curProcess}%), 0, 0)`
              // 重置定位时，不显示动画
              if(this.showAnimation) {
                style.transition = "all 0.4s ease-in-out 0s"
              }
              if(!this.showAnimation) {
                this.showAnimation = true
              }
              // resetFlag为-1，表示0坐标向左偏移，先重置到length，延时后切换到length - 1
              if(this.resetFlag === -1) {
                setTimeout(() => {
                  this.startIndex = this.selectOptions.length - 1
                  this.resetFlag = 0
                  this.showAnimation = true
                })
              }
            }
          } else {
            style.width = "100%"
          }
        }
      }
      return style
    },
  },
  methods: {
    getItemWidth(index) {
      let style = {}
      let length = this.options.showColNumber
      if (this.options.widthAuto) {
        style["width"] = parseFloat(100 / length).toFixed(2) + "%"
      } else {
        // 取模是因为循环切换时，会复制一组数据
        style["width"] = this.options.widthList[index % this.options.widthList.length] + "%"
      }
      return style
    },
    async getGeneralRest(appId, wfwfid, websiteId, pageId) {
      return this.$API.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: pageId
      })
    },
    doObj(datas, targetData) {
      for (let key in datas) {
        targetData.push({
          label: datas[key].name,
          value: datas[key].url,
          iconUrl: datas[key].iconUrl,
          publicId: datas[key].publicId,
          openTarget: datas[key].openTarget, // 1 当前窗口 2 新窗口
          openType: datas[key].openType, // 1 自定义页面 2 链接地址
          showType: datas[key].showType, // openType === 1 时  【0: 默认，1：列表、2：简介、3：简介+列表 4：简介+分类列】
          children: []
        })
        if (typeof datas[key].subGeneralDataTypes == "object") {
          this.doObj(datas[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    setMyFetchParam(appId) {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      this.$changeOptionsEV(
        {
          pageId: pageId,
          wfwfid,
          websiteId,
          appId
        },
        "myFetchParam",
        false,
        null,
        {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id
        },
        true
      )
    },
    handleRepairApp(appId) {
      // 根据当前appid，获取到对应的组件
      const _ids = this.ids
      const options = this.options
      // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
      const isSearchComponent = options.pluginName?.includes("searchComponentPlugin")
      const isNavComponent = options.innerElement.toLowerCase().includes("nav")
      repairApp.call(this, "31CB73E03E24BBFF", "临时", appId, false, isSearchComponent, isNavComponent).then(res => {
        // 替换原来的appId
        console.log("// 替换原来的appId", _ids)
        if (!!res.appId) {
          this.$changeOptionsEV(res.appId, "appId", null, false, _ids)
        }
      })
    },
    async initNavData() {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      const appId = this.options.appId
      let res = await this.getGeneralRest(appId, wfwfid, websiteId, pageId)
      let datas,
        targetData = []
      this.setMyFetchParam(appId) // 设置请求参数
      // 脏数据处理
      if (res.data.message === "mh_engine_40009") {
        this.handleRepairApp(appId)
      }
      if (res.data.code === 1) {
        const engineInstanceId = res.data.data.engineInstance.publicId
        this.$changeOptionsEV(engineInstanceId, "engineInstanceId", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id
        })
        datas = res.data.data.generalDataTypes
        this.engineInstanceRealId = res.data.data.engineInstance.id
        //获取数据推送需要的属性
        this.$changeOptionsEV(res.data.data.engineInstance.id, "engineInstanceId_10", false)
        this.doObj(datas, targetData)
        this.$changeOptionsEV(targetData, "selectOptions", false)
      }
    },
    buttonClick(type) {
      if (!this.canSwitchPage) {
        return
      }
      switch (type) {
        case "prev":
          // 防止点击太快，重置时动画还未执行完成
          if(this.resetFlag) {
            return
          }
          if (this.startIndex === 0) {
            // 先重置为length，延时器后重置为length - 1
            this.startIndex = this.selectOptions.length
            this.showAnimation = false
            this.resetFlag = -1
          } else {
            this.startIndex--
          }
          break
        case "next":
          // 防止点击太快，重置时动画还未执行完成
          if(this.resetFlag) {
            return
          }
          if (this.startIndex === this.selectOptions.length - 1) {
            // 先把下标右移，动画结束后重置到0
            this.startIndex++
            this.resetFlag = 1
          } else {
            this.startIndex++
          }
          break
      }
    },
    async selectClick(index, select, type) {
      if (type === "title") {
        if (!select.children || select.children.length === 0) {
          this.titleActiveIndex = index
          this.subActiveIndex = null
        }
      } else if (type === "sub") {
        this.titleActiveIndex = null
        this.subActiveIndex = index
      }
    },
    transitionEnd(event) {
      // resetFlag为1，表示在过渡动画结束后，重置偏移位置为0，此时需要同时关闭动画
      if(this.resetFlag === 1) {
        this.showAnimation = false
        this.startIndex = 0
        this.resetFlag = 0
      }
    }
  },
  mounted() {
    if (this.options.appId) {
      this.initNavData()
    }
    this.$refs.wrapRef.addEventListener('transitionend', this.transitionEnd, false)
  },
  beforeDestroy() {
    this.$refs.wrapRef.removeEventListener('transitionend', this.transitionEnd, false)
  }
}
</script>

<style scoped>
.repeat-nav-container {
  text-align: left;
  height: 100%;
  overflow: hidden;
}

.repeat-nav-container .inner-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.repeat-nav-container .vertical {
  display: flex;
}

.repeat-nav-container .horizontal {
  height: 100%;
  overflow-y: auto;
}

.repeat-nav-container .vertical .nav-item {
  display: inline-block;
  vertical-align: top;
}

.pointer {
  cursor: pointer;
}

.nav-title {
  white-space: nowrap;
  color: var(--color) !important;
  font-size: var(--fontSize);
  font-family: var(--fontFamily);
  font-weight: var(--fontWeight);
  line-height: var(--lineHeight);
  width: var(--width);
  /*height: var(--lineHeight);*/
  text-align: var(--textAlign);
  text-decoration: var(--textDecoration);
  letter-spacing: var(--letterSpacing);
  writing-mode: var(--writingMode);
  font-style: var(--fontStyle);
  border-width: var(--borderWidth);
  border-style: var(--borderStyle);
  border-color: var(--borderColor) !important;
  box-shadow: var(--boxShadow);
  background-image: var(--backgroundImage);
  background-size: var(--backgroundSize);
  background-position: var(--backgroundPosition);
  background-repeat: var(--backgroundRepeat);
  background-color: var(--backgroundColor);
  border-radius: var(--borderRadius);
  padding: var(--padding);
}

.nav-title:hover,
.nav-title.active {
  color: var(--activeColor) !important;
  font-size: var(--activeFontSize);
  font-family: var(--activeFontFamily);
  font-weight: var(--activeFontWeight);
  line-height: var(--activeLineHeight);
  /*height: var(--activeLineHeight);*/
  text-align: var(--activeTextAlign);
  text-decoration: var(--activeTextDecoration);
  letter-spacing: var(--activeLetterSpacing);
  writing-mode: var(--activeWritingMode);
  font-style: var(--activeFontStyle);
  border-width: var(--activeBorderWidth);
  border-style: var(--activeBorderStyle);
  border-color: var(--activeBorderColor) !important;
  box-shadow: var(--activeBoxShadow);
  background-image: var(--activeBackgroundImage);
  background-size: var(--activeBackgroundSize);
  background-position: var(--activeBackgroundPosition);
  background-repeat: var(--activeBackgroundRepeat);
  background-color: var(--activeBackgroundColor);
  border-radius: var(--activeBorderRadius);
  padding: var(--activePadding);
}

.nav-submenu,
.more-btn {
  color: var(--color) !important;
  font-size: var(--fontSize);
  font-family: var(--fontFamily);
  font-weight: var(--fontWeight);
  line-height: var(--lineHeight);
  /*height: var(--lineHeight);*/
  text-align: var(--textAlign);
  text-decoration: var(--textDecoration);
  letter-spacing: var(--letterSpacing);
  writing-mode: var(--writingMode);
  font-style: var(--fontStyle);
  border-width: var(--borderWidth);
  border-style: var(--borderStyle);
  border-color: var(--borderColor) !important;
  box-shadow: var(--boxShadow);
  background-image: var(--backgroundImage);
  background-size: var(--backgroundSize);
  background-position: var(--backgroundPosition);
  background-repeat: var(--backgroundRepeat);
  background-color: var(--backgroundColor);
  border-radius: var(--borderRadius);
  padding: var(--padding);
  cursor: pointer;
}
.more-btn{
  height: var(--lineHeight);
}
.nav-submenu:hover,
.nav-submenu.active,
.more-btn:hover {
  color: var(--activeColor) !important;
  font-size: var(--activeFontSize);
  font-family: var(--activeFontFamily);
  font-weight: var(--activeFontWeight);
  line-height: var(--activeLineHeight);
  /*height: var(--activeLineHeight);*/
  text-align: var(--activeTextAlign);
  text-decoration: var(--activeTextDecoration);
  letter-spacing: var(--activeLetterSpacing);
  writing-mode: var(--activeWritingMode);
  font-style: var(--activeFontStyle);
  border-width: var(--activeBorderWidth);
  border-style: var(--activeBorderStyle);
  border-color: var(--activeBorderColor) !important;
  box-shadow: var(--activeBoxShadow);
  background-image: var(--activeBackgroundImage);
  background-size: var(--activeBackgroundSize);
  background-position: var(--activeBackgroundPosition);
  background-repeat: var(--activeBackgroundRepeat);
  background-color: var(--activeBackgroundColor);
  border-radius: var(--activeBorderRadius);
  padding: var(--activePadding);
}
.more-btn:hover{
  height: var(--activeLineHeight);
}
.more-btn {
  white-space: nowrap;
  cursor: pointer;
}

.button_style {
  position: absolute;
  z-index: 999;
  width: var(--button-box-width);
  height: var(--button-box-height);
  border-radius: var(--button-box-border-radius);
  background: var(--button-box-background);
  box-shadow: var(--button-box-shadow);
  display: flex;
  align-items: center;
  justify-content: center;
}

.button_style:hover {
  opacity: 0.5;
}

.button_style .icon {
  font-size: var(--swiper-button-size);
  color: var(--swiper-button-color);
  top: 0;
}

.button-style .icon:before {
  color: var(--swiper-button-color);
}

.button-next {
  right: var(--button-box-right-x);
  top: var(--button-box-right-y);
}

.button-prev {
  left: var(--button-box-left-x);
  top: var(--button-box-left-y);
}

.button_style::before {
  color: var(--swiper-button-color);
  font-size: var(--swiper-button-size);
}

.button-next {
  transform: rotate(180deg);
}
</style>
